/* eslint-disable */
/** *
 * 验证输入信息
 * * */
export function ltrim(s) {
  return s.replace(/^\s*/, '');
}

export function rtrim(s) {
  return s.replace(/\s*$/, '');
}

export function trim(s) {
  return rtrim(ltrim(s));
}

export function checkNumber(num) {
  const filter = /^-?([0-9][0-9]*|0)(\.[0-9]+)?$/;
  return filter.test(num);
}

export function checkPositiveNumber(num) {
  // 非中国手机号，可以以0打头（例：英国），位数不固定
  const filter = /^\d*$/;
  return filter.test(num);
}

export function checkEmail(email) {
  // consistent with OKX
  const filter =
    /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,20}|[0-9]{1,3})(\]?)$/;
  return filter.test(email);
}

export function checkMobile(mobile) {
  const filter = /^1[3|4|5|8|7][0-9]\d{8}$/;
  return filter.test(mobile);
}

export function checkInternationalMobile(mobile) {
  const filter = /^[0-9]{3,15}$/;
  return filter.test(mobile);
}

export function checkNumberByObj(value, lenth) {
  const number = value.split('.');
  if (lenth <= 0) {
    return number[0].replace(/\D/g, '');
  }
  if (number.length > 1) {
    return `${number[0].replace(/\D/g, '')}.${number[1]
      .replace(/\D/g, '')
      .slice(0, lenth)}`;
  }
  return number[0].replace(/\D/g, '');
}

export function filterNumber(value) {
  return value ? value.replace(/\D/g, '') : '';
}

/**
 * 校验是否包含中文字符
 * @param value
 * @returns {*}
 */
export function checkChinese(value) {
  // Unicode编码中的汉字范围
  const reg = /[\u4E00-\u9FA5]/i;
  return reg.test(value);
}

/**
 * 校验是否为片假字
 * @param value
 * @returns {*}
 */
export function checkJP(value, checkNone = true) {
  // Unicode编码中的汉字范围
  const reg = /^[\u30A0-\u30FF]+$/i;
  if (checkNone && value == 'NONE') {
    return true;
  }
  return reg.test(value);
}

/** 日本語名前チェック / 校验日语姓名
 * @param value
 * @returns {*}
 */
export function checkJpName(value) {
  // 全角漢字、片仮名、平仮名
  // 漢字: [\u4E00-\u9fA0]
  // 片仮名: [\u30A0-\u30FF]
  // 平仮名: [\u3040-\u309F]
  // 特殊表記: [々ゝゞー]
  const reg = /^([\u4E00-\u9fA0]|[\u30A0-\u30FF]|[\u3040-\u309F]|[々ゝゞー])+$/;
  return reg.test(value);
}

/** 銀行名義チェック個人
 * @param value
 * @returns {*}
 */
export function checkJpCardName(value) {
  // 半角英字: [a-zA-Z]
  // 片仮名: [\u30A0-\u30FF]
  // ただし、半角全角スペース(開始と終了を除く)
  const reg = /^([\u30A0-\u30FF\s]|[a-zA-Z\s])+$/;
  const regStartSpace = /^\s+/; // spaceで開始
  const regEndSpace = /\s+$/; // spaceで終了
  return (
    reg.test(value) && !regStartSpace.test(value) && !regEndSpace.test(value)
  );
}

/** 銀行名義チェック法人
 * @param value
 * @returns {*}
 */
export function checkJpCardNameCompany(value) {
  // 漢字は不可
  const reg = /^[^\u4E00-\u9fA0]+$/;
  return reg.test(value);
}

/** 英名前チェック / 校验英文姓名
 * @param value
 * @returns {*}
 */
export function checkEnName(value) {
  const reg = /^[a-zA-Z]+$/;
  return reg.test(value);
}

/** Sygna英名前チェック / 校验Sygna英文姓名
 *  This field only accepts
 *  alphabet
 *  numbers(0-9)
 *  space, dash(-)
 *  comma(,),
 *  dot(.),
 *  apostrophe(')
 *  double quote(")
 *  underline(_)
 *  parentheses()
 * @param value
 * @returns {*}
 */
export function checkSygnaEnName(value) {
  const reg = /^[a-zA-Z0-9| |\.|\,|\-|\'|\"|_|(|)]+$/;
  return reg.test(value);
}

/**
 * 郵便番号チェック / 校验邮政编码
 * @param value
 * @returns {*}
 */
export function checkJpPostcode(value) {
  // ハイフンなしの7桁数値
  const reg = /^\d\d\d\d\d\d\d$/;
  return reg.test(value);
}

/**
 * 住所欄チェック / 校验详细地址
 * @param value
 * @returns {*}
 */
export function checkJpAddress(value) {
  //  // 全角漢字、片仮名、平仮名
  //  // 漢字: [\u4E00-\u9fA0]
  //  // 片仮名: [\u30A0-\u30FF]
  //  // 平仮名: [\u3040-\u309F]
  //  // 特殊表記: [々ゝゞー]  \u3000: 全角スペース  \u0020: 半角スペース   \u30fc: 全角ハイフン
  //  // その他住所で使える記号: [\uFFEF-\uFF00]
  //  const reg = /^([\u4E00-\u9fA0]|[\u30A0-\u30FF]|[\u3040-\u309F]|[々ゝゞー\u3000\u0020\u30fc]|[\uFF00-\uFFEF])+$/;
  //  return reg.test(value);
  //　ユーザー利便性向上させるために文字数制限のみかけるようにする
  return value.length <= 100;
}

/**
 * 校验只能输入字母
 * @param value
 * @returns {boolean}
 */
export function checkLetter(value) {
  const reg = /^[a-z]+$/i;
  return !reg.test(value);
}

/**
 * 验证是否为正整数
 * */
export function checkInt(num) {
  const filter = /^[0-9]\d*$/;
  return filter.test(num);
}

/**
 * 全角英数字チェック
 * */
export function checkIfFullWidthEngAndNum(value) {
  const reg = /[ａ-ｚＡ-Ｚ０-９]/;
  return reg.test(value);
}

/**
 * 半角カタカナチェック
 * */
export function checkIfContainHalfWidthKatakanaOrSymbol(value) {
  const reg = /[\uFF61-\uFF9F]/;
  return reg.test(value);
}

/**
 * 减法
 */
export function accSub(arg1, arg2) {
  let r1;
  let r2;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  const m = 10 ** Math.max(r1, r2);
  const n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 * 乘法
 */
export function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {
    // return '';
  }
  try {
    m += s2.split('.')[1].length;
  } catch (e) {
    // return '';
  }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / 10 ** m;
}
